/* eslint-disable no-unused-expressions */
/* eslint-disable no-console */
import React, { useEffect } from 'react';
import { Row, Col } from '@thd-olt-component-react/core-ui';
import { Typography } from '@one-thd/sui-atomic-components';
import { useDimensionsStore, useCompatibilityStore } from '../../../store';
import { useDesignStore } from '../../../store/design/context';
import HeightMatrix from './heightMatrix';
import { depthCalculator } from './depthCalculator';
import { widthCalculator } from './widthCalculator';

const DimensionsBar = () => {
  const {
    getSkuProductDimensions,
    stackDimensions,
    updateStackDimensions,
    skuDimensions
  } = useDimensionsStore((state) => state);

  const { height, width, depth } = stackDimensions;

  const {
    getCompatibilitySegmentGroupsByProductType,
    getCompatibilitySegmentGroups,
    getCompatibilitySegmentGroupsBySize,
    compatibilitySegments
  } = useCompatibilityStore((state) => state);

  const { products } = useDesignStore((state) => state).design;

  const calculateWidth = widthCalculator(compatibilitySegments, getSkuProductDimensions);

  const calculateDepth = depthCalculator(compatibilitySegments, getSkuProductDimensions);

  const calculateDimensions = (
    fullProductGroupNames,
    halfProductGroupNames,
    xlProductGroupNames,
    baseProductGroupsNames
  ) => {
    const packHeight = new HeightMatrix(
      4,
      4,
      getSkuProductDimensions,
      getCompatibilitySegmentGroups,
      compatibilitySegments).calculateMaxHeight();
    const packWidth = calculateWidth(
      fullProductGroupNames,
      halfProductGroupNames,
      xlProductGroupNames,
      baseProductGroupsNames
    );
    const packDepth = calculateDepth(
      fullProductGroupNames,
      halfProductGroupNames,
      xlProductGroupNames,
      baseProductGroupsNames
    );
    updateStackDimensions({ height: packHeight, width: packWidth, depth: packDepth });
  };

  useEffect(() => {
    if (!skuDimensions || Object.keys(skuDimensions).length === 0) return;
    const fullProductGroupNames = getCompatibilitySegmentGroupsBySize('2x4');
    const halfProductGroupNames = getCompatibilitySegmentGroupsBySize('2x2');
    const xlProductGroupNames = getCompatibilitySegmentGroupsBySize('4x4'); // DXL
    const baseProductGroupsNames = getCompatibilitySegmentGroupsByProductType('Base');
    calculateDimensions(fullProductGroupNames, halfProductGroupNames, xlProductGroupNames, baseProductGroupsNames);
  }, [compatibilitySegments, skuDimensions, products]);

  return (
    <Row className="dimensions-grid">
      <Col className="dimensions-col" fallback="12" xs={4} md={4} lg={4}>
        <Typography
          variant="body-xs"
          color="inverse"
          weight="bold"
        >{`Height: ${height.toFixed(2)} in.`}
        </Typography>
      </Col>
      <Col className="dimensions-col" fallback="12" xs={4} md={4} lg={4}>
        <Typography
          variant="body-xs"
          color="inverse"
          weight="bold"
        >{`Width: ${width?.toFixed(2)} in.`}
        </Typography>
      </Col>
      <Col className="dimensions-col" fallback="12" xs={4} md={4} lg={4}>
        <Typography
          variant="body-xs"
          color="inverse"
          weight="bold"
        >{`Depth: ${depth?.toFixed(2)} in.`}
        </Typography>
      </Col>
    </Row>
  );
};

export default DimensionsBar;
